if (!customElements.get('video-multicolumn')) {
  class VideoMulticolumn extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[data-slick-slider]');
      this.initSlider();
      this.initVideoPlayers();
    }

    initSlider() {
      if (!this.slider) return;
      
      const init = () => {
        if (typeof window.jQuery !== 'undefined' && window.jQuery.fn.slick) {
          const config = JSON.parse(this.slider.getAttribute('data-slick-config'));
          const customPrevArrow = this.querySelector('.video-multicolumn__arrow--prev');
          const customNextArrow = this.querySelector('.video-multicolumn__arrow--next');
          
          if (customPrevArrow && customNextArrow) {
            config.prevArrow = window.jQuery(customPrevArrow);
            config.nextArrow = window.jQuery(customNextArrow);
          }
          
          window.jQuery(this.slider).slick(config);
        } else {
          setTimeout(init, 100);
        }
      };
      init();
    }

    initVideoPlayers() {
      const wrappers = this.querySelectorAll('.video-multicolumn__media-wrapper');
      wrappers.forEach(wrapper => {
        const playBtn = wrapper.querySelector('.video-multicolumn__play-btn');
        const videoNative = wrapper.querySelector('video');
        const iframe = wrapper.querySelector('iframe');

        if (playBtn) {
          playBtn.addEventListener('click', () => {
            // Pause all other active videos in this section
            this.querySelectorAll('.video-multicolumn__media-wrapper.is-playing').forEach(activeWrapper => {
              if (activeWrapper !== wrapper) {
                activeWrapper.classList.remove('is-playing');
                const v = activeWrapper.querySelector('video');
                const i = activeWrapper.querySelector('iframe');
                if (v) {
                  v.pause();
                  v.removeAttribute('controls');
                }
                if (i) i.setAttribute('src', ''); // Stop iframe playback heavily
              }
            });

            // Play clicked video
            wrapper.classList.add('is-playing');

            if (videoNative) {
              videoNative.setAttribute('controls', '');
              videoNative.play();
            } else if (iframe) {
              const dataSrc = iframe.getAttribute('data-src');
              if (dataSrc && iframe.getAttribute('src') !== dataSrc) {
                iframe.setAttribute('src', dataSrc);
              }
            }
          });
        }
      });
    }
  }
  customElements.define('video-multicolumn', VideoMulticolumn);
}